import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["scene", "width", "height", "data", "config", "theme", "tooltipRender", "formatter", "chartDidMount", "chartLegendChange", "className", "showDownloadImg", "selfAdaptiveWidth"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import ConfigConsumerProvider from '@jd/jmtd/es/ConfigConsumerProvider';
import Echart from '../Echart';
export default function ChartHOC(configs, render) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$noData = _ref.noData,
      noData = _ref$noData === void 0 ? function (_ref2) {
    var series = _ref2.series,
        categories = _ref2.categories;
    return !(series !== null && series !== void 0 && series.length) || !(categories !== null && categories !== void 0 && categories.length);
  } : _ref$noData;

  function Chart(_ref3) {
    var scene = _ref3.scene,
        width = _ref3.width,
        height = _ref3.height,
        data = _ref3.data,
        config = _ref3.config,
        theme = _ref3.theme,
        tooltipRender = _ref3.tooltipRender,
        formatter = _ref3.formatter,
        chartDidMount = _ref3.chartDidMount,
        chartLegendChange = _ref3.chartLegendChange,
        className = _ref3.className,
        showDownloadImg = _ref3.showDownloadImg,
        selfAdaptiveWidth = _ref3.selfAdaptiveWidth,
        other = _objectWithoutProperties(_ref3, _excluded);

    return /*#__PURE__*/React.createElement(ConfigConsumerProvider, {
      chartTheme: theme
    }, function (_ref4) {
      var _ref5, _configs$chartTheme;

      var chartTheme = _ref4.chartTheme;
      var themeConfig = (_ref5 = (_configs$chartTheme = configs[chartTheme]) !== null && _configs$chartTheme !== void 0 ? _configs$chartTheme : configs.default) !== null && _ref5 !== void 0 ? _ref5 : {};
      return /*#__PURE__*/React.createElement(Echart, {
        key: noData(data),
        data: data,
        className: className,
        tooltipRender: tooltipRender,
        formatter: formatter,
        width: width,
        height: height,
        noData: noData(data),
        chartDidMount: chartDidMount,
        chartLegendChange: chartLegendChange,
        isMini: scene.includes('mini-'),
        showDownloadImg: showDownloadImg,
        selfAdaptiveWidth: selfAdaptiveWidth,
        chartConfig: render(_objectSpread(_objectSpread({}, data), {}, {
          config: config,
          scene: scene,
          themeConfig: themeConfig,
          formatter: formatter,
          chartTheme: chartTheme
        }), other)
      });
    });
  }

  Chart.propTypes = {
    theme: PropTypes.string,
    className: PropTypes.string,
    scene: PropTypes.string,
    data: PropTypes.object,
    config: PropTypes.object,
    tooltipRender: PropTypes.func,
    formatter: PropTypes.func,
    chartDidMount: PropTypes.func,
    chartLegendChange: PropTypes.func,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    showDownloadImg: PropTypes.bool
  };
  Chart.defaultProps = {
    theme: null,
    height: null,
    width: null,
    className: '',
    scene: '',
    data: {
      categories: [],
      series: []
    },
    config: {},
    tooltipRender: undefined,
    formatter: function formatter(x) {
      return x;
    },
    chartDidMount: function chartDidMount() {},
    chartLegendChange: function chartLegendChange() {},
    showDownloadImg: false
  };
  return Chart;
}